import { render, staticRenderFns } from "./PatientAppointment.vue?vue&type=template&id=2bf687cd&scoped=true"
import script from "./PatientAppointment.vue?vue&type=script&lang=js"
export * from "./PatientAppointment.vue?vue&type=script&lang=js"
import style0 from "./PatientAppointment.vue?vue&type=style&index=0&id=2bf687cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf687cd",
  null
  
)

export default component.exports